<template>
    <BaseBtn
        class="ui-btn"
        :href="href"
        @click="click"
        :class="classes"
    >
        <div class="flex">
            <div class="px-5 py-3">
                <slot></slot>
            </div>
            <div class="ui-btn__icon flex items-center h-auto px-5 border-l border-midnight">
                <IconRenderer
                    name="DoubleChevron"
                    class="w-6 fill-current"
                    :class="chevronDirection === 'right' ? ['transform', '-rotate-90'] : []"
                />
            </div>
        </div>
    </BaseBtn>
</template>

<script>
export default {
    props: {
        route: null,
        href: String,
        variant: {
            type: String,
            default: 'alpha'
        },
        chevronDirection: {
            type: String,
            default: 'right'
        }
    },

    computed: {
        classes() {
            return [`ui-btn--${this.variant}`];
        }
    },

    methods: {
        click() {
            if (this.route) {
                this.$router.push(this.route);
            }

            this.$emit('click');
        }
    }
}
</script>

<style>
.ui-btn {
    &:hover {
        @apply underline;

        &.ui-btn--alpha {
            .ui-btn__icon {
                @apply bg-midnight text-golden-fizz;
            }
        }
    }

    &.base-btn {
        @apply p-0 h-auto border-midnight;
    }

    &--alpha {
        .ui-btn__icon {
            @apply bg-golden-fizz;
        }
    }

    &--beta {
        &.base-btn {
            @apply p-0 h-auto border-white text-golden-fizz;
        }

        .ui-btn__icon {
            @apply border-l border-white;

            .icon-double-chevron {
                @apply text-golden-fizz;
            }
        }
    }

    &__icon {
        transition: background-color 400ms, color 400ms;
    }
}
</style>
